<template>
	<div>
		<div class="page-header" v-if="$slots.head || $slots.cta">
			<div class="header-content">
				<div class="head flex-grow-1">
					<slot name="head"></slot>
				</div>

				<div class="cta">
					<slot name="cta"></slot>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {}
</script>
<style scoped>
.head {
	background-color: #fff;
	padding: 0px 32px;
	align-self: end;
}

.page-header {
	margin-bottom: 8px;
	margin: 0px;
	width: 100%;
	background: #fff;
	z-index: 10;
	border-bottom: 1px solid #d3d9db;
}

.page-header .header-content {
	min-height: 56px;
	padding: 0px 16px;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
}

.page-header-spacer {
	width: 100%;
	height: 56px;
}

@media (max-width: 991px) {
	.page-header {
		width: 100%;
	}
}
</style>
